import React, { useMemo } from 'react';

export default function CsrfToken() {
  const token = useMemo(
    () => document.querySelector('[name=csrf-token]').content,
    []
  );

  return <input type='hidden' name='_token' value={token} />;
}
